import React from 'react';
import { IconButton, Stack } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { TimeHelper } from '../../../utils';

import styles from './OverviewHeader.module.scss';

type Props = {
  date: number;
  timezone: string;
  onBackClick: () => void;
};

export function OverviewHeader({ date, onBackClick, timezone }: Props) {
  return (
    <div className={styles.header}>
      <div className={styles.navigation}>
        <Stack direction="row" alignItems="center">
          <IconButton color="primary" disableRipple onClick={onBackClick}>
            <ArrowBackIosIcon />
          </IconButton>
          <span className={styles.title}>{TimeHelper.toMonthAndYearFormat(date, timezone)}</span>
        </Stack>
      </div>
    </div>
  );
}
